import { isIosNativeAppRuntime } from './runtimeCapabilities';

const ENABLED_VALUES = new Set(['1', 'true', 'yes', 'on', 'enabled']);

export function isIosDevAccessUnlocked(): boolean {
  if (!isIosNativeAppRuntime()) return false;
  const viteRaw = (import.meta as any).env?.VITE_IOS_DEV_UNLOCK ?? '';
  const testRaw = typeof process !== 'undefined' ? process.env?.VITE_IOS_DEV_UNLOCK : '';
  const raw = String(viteRaw || testRaw || '').trim().toLowerCase();
  return ENABLED_VALUES.has(raw);
}
